import ErrorScreen from "./ErrorScreen";
import ForbiddenScreen from "./ForbiddenScreen";

export { ForbiddenScreen };

export default ErrorScreen;